module.exports = __webpack_public_path__ + "img/symbol_15.63ac8072.png";